import { PlaycastButton, PlaycastVector } from './core';
import { PlaycastSystemPlayerCoordinates } from './system';

export const XInputValues = {
  DPAD_UP: 0x0001,
  DPAD_DOWN: 0x0002,
  DPAD_LEFT: 0x0004,
  DPAD_RIGHT: 0x0008,
  START: 0x0010,
  BACK: 0x0020,
  LEFT_THUMB: 0x0040,
  RIGHT_THUMB: 0x0080,
  LEFT_SHOULDER: 0x0100,
  RIGHT_SHOULDER: 0x0200,
  A: 0x1000,
  B: 0x2000,
  X: 0x4000,
  Y: 0x8000,

  // Placeholder values for triggers (Not actual bitmasks)
  LEFT_TRIGGER: 0x0300,
  RIGHT_TRIGGER: 0x0400,
};

export type PlaycastTrigger = PlaycastButton & {
  value: number;
};

export type PlaycastStick = {
  stick: PlaycastVector;
  button: PlaycastButton;
};

export type PlaycastGamepadState = {
  playerCoordinates: PlaycastSystemPlayerCoordinates;
  gamepads: PlaycastGamepadDevice[];
};

export type PlaycastGamepadId = -1 | 0 | 1 | 2 | 3; // -1 means unassigned

export type PlaycastPlayerDevice = {
  playerId: string;
  deviceId: number;
};

export type PlaycastPlayerDeviceGamepad = PlaycastPlayerDevice & {
  gamepadId: PlaycastGamepadId;
};

export type PlaycastPlayerDeviceGamepadMap = PlaycastPlayerDeviceGamepad[];

export type XInput = {
  wButtons: number;
  bLeftTrigger: number;
  bRightTrigger: number;
  sThumbLX: number;
  sThumbLY: number;
  sThumbRX: number;
  sThumbRY: number;
};

export type PlaycastGamepadDevice = {
  deviceId: number;
  id: string;
  timestamp: DOMHighResTimeStamp;
  xInput: XInput;
};

export type PlaycastGamepadXInput = {
  gamepadId: -1 | 0 | 1 | 2 | 3; // -1 means unassigned
  playerCoordinates: PlaycastSystemPlayerCoordinates;
  xInput: XInput;
};

export type PlaycastHostOneGamepadState = {
  gamepadId: PlaycastGamepadId;
  connected: boolean;
  isPhysical: boolean;
  name: string;
  orderAdded: number;
  playerId?: string;
}

export type PlaycastHostGamepadState = {
  gamepads: PlaycastHostOneGamepadState[];
  raw?: Record<string, any>;
}

